module.exports = __webpack_public_path__ + "static/media/7_14.1b5f5aa5.png";